import Cryptr from 'cryptr';
import { SECRET_KEY } from '@/shared/config-global';

const cryptr = new Cryptr(SECRET_KEY);

export const encryptData = (data: any) => cryptr.encrypt(JSON.stringify(data));

export const decryptData = (encryptedString: string) => JSON.parse(cryptr.decrypt(encryptedString));
